import { createReducer, on } from '@ngrx/store';
import { Customer, CustomerSummary } from '../../../models/consumer';
import { cleanAccountSummary, loadCustomer, loadCustomerFinished, loadCustomerSummary, loadCustomerSummaryFinished } from './../customer-summary/customer-summary.actions';
import { ContactResponse } from '../../../admin/interfaces/find-email.interface';
import { assignOrRevokePermission, cleanAccountContact, loadCustomerContacts, loadCustomerContactsFailed, loadCustomerContactsFinished, loadLiveLink, loadLiveLinkFinished, setContactActiveStatus } from './customer.actions';

export const customerFeatureKey = 'customer';

export interface CustomerState {
    information: Customer;
    customerSummary: CustomerSummary;
    contacts: ContactResponse[] | null;
    contactsLoading: boolean;
    liveLinkLoading: boolean;
    livelinkUrl: string | undefined;
    livelinkExpiry: string | undefined;
}

export const initialState: CustomerState = {
    information: {},
    customerSummary: {},
    contacts: null,
    contactsLoading: false,
    liveLinkLoading: false,
    livelinkUrl: undefined,
    livelinkExpiry: undefined
};

export const customerSummaryReducer = createReducer(
    initialState,
    on(loadCustomer, (state: CustomerState, { customer }: { customer?: Customer }) => {
        return customer?.Id ? { ...state, information: { ...customer } } : state;
    }),
    on(loadCustomerFinished, (state: CustomerState, { customer }: { customer?: Customer }) => {
        return customer?.Id ? { ...state, information: { ...customer } } : state;
    }),
    on(loadCustomerSummary, (state: CustomerState, { summary }: { summary?: CustomerSummary }) => {
        return summary ? { ...state, customerSummary: { ...summary } } : state;
    }),
    on(loadCustomerSummaryFinished, (state: CustomerState, { summary }: { summary?: CustomerSummary }) => {
        return summary ? { ...state, customerSummary: { ...summary } } : state;
    }),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    on(cleanAccountSummary, (state: CustomerState) => {
        return initialState;
    }),
    on(loadCustomerContacts, (state: CustomerState) => ({
        ...state,
        contactsLoading: true
    })),
    on(setContactActiveStatus, (state: CustomerState) => ({
        ...state,
        contactsLoading: true
    })),
    on(loadCustomerContactsFinished, (state: CustomerState, { contacts }) => ({
        ...state,
        contactsLoading: false,
        contacts
    })),
    on(loadCustomerContactsFailed, (state: CustomerState) => ({
        ...state,
        contactsLoading: false
    })),
    on(cleanAccountContact, (state: CustomerState) => ({
        ...state,
        contacts: null,
        contactsLoading: false
    })),
    on(assignOrRevokePermission, (state: CustomerState, { data }) => {
        if (!state.contacts) {
            return state;
        }
        const updatedContacts = state.contacts.map(contact => {
            if (contact.email?.toLowerCase() !== data.email.toLowerCase()) {
                return contact;
            }
            return {
                ...contact,
                permissions: { ...contact.permissions, [data.permission]: data.enabled }
            };
        });
        return {
            ...state,
            contacts: updatedContacts
        };
    }),
    on(loadLiveLink, (state: CustomerState) => {
        return {
            ...state,
            liveLinkLoading: true
        };
    }),
    on(loadLiveLinkFinished, (state: CustomerState, { livelinkUrl, livelinkExpiry }) => {
        return {
            ...state,
            liveLinkLoading: false,
            livelinkUrl,
            livelinkExpiry
        };
    })
);
